import AddProduct from './AddProduct';
import CustomerForm from './Customer';
import OrderItems from './OrderItems';
import SubmitOrder from './SubmitOrder';
import Discount from './Discount';

export default function CreateOrderPage() {
  const token = JSON.parse(localStorage.getItem('token') || '{}');
  const vanid = token?.userid ?? null;

  return (
    <>
      <h2>Create Order</h2>
      <AddProduct vanid={vanid} />
      <OrderItems />
      <Discount />
      <CustomerForm vanid={vanid}/>
      <SubmitOrder />
    </>
  );
}
